// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReadinessDetail-module__root___xV3KU {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.04);
}

.ReadinessDetail-module__sectionHeader___ocXVd {
  padding: 14px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.ReadinessDetail-module__headerTop___EgaUC {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
}

.ReadinessDetail-module__patientName___AXlVZ {
  font-size: 17px;
  font-weight: 600;
  color: #18181b;
  line-height: 1.35;
}

.ReadinessDetail-module__visitType___C4qE5 {
  font-size: 14px;
  color: #52525b;
  margin-top: 2px;
}

.ReadinessDetail-module__closeButton___j0ffB {
  background: none;
  border: none;
  font-size: 16px;
  color: #a1a1aa;
  cursor: pointer;
  padding: 0;
}

.ReadinessDetail-module__closeButton___j0ffB:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.ReadinessDetail-module__badgesRow___CT_sm {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 8px;
}

.ReadinessDetail-module__visitDescription___UYUk4 {
  font-size: 13px;
  color: #71717a;
  line-height: 1.5;
}

.ReadinessDetail-module__sectionInfo___MgFiV {
  padding: 10px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.ReadinessDetail-module__infoGrid___ACJCM {
  display: grid;
  grid-template-columns: 72px 1fr;
  gap: 4px 0;
  font-size: 13px;
  margin-bottom: 8px;
}

.ReadinessDetail-module__infoRow___mEYHw {
  display: contents;
}

.ReadinessDetail-module__infoLabel___wM8fF {
  color: #a1a1aa;
  font-weight: 500;
}

.ReadinessDetail-module__infoValue___UDxWu {
  color: #3f3f46;
}

.ReadinessDetail-module__linkWrap___PC0Da {
  margin-top: 8px;
}

.ReadinessDetail-module__noteLink___zhTX9 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  margin-top: 6px;
  background: #fefce8;
  border: 1px solid #fde68a;
  border-radius: 6px;
  text-decoration: none;
  color: #18181b;
  cursor: pointer;
  transition: border-color 0.15s;
}

.ReadinessDetail-module__noteLink___zhTX9:hover {
  border-color: #eab308;
}

.ReadinessDetail-module__noteLink___zhTX9:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.ReadinessDetail-module__noteBadge___AmpjM {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  background: #854d0e;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ReadinessDetail-module__noteBadgeText___hOfMV {
  font-size: 10px;
  font-weight: 700;
  color: #fefce8;
  font-family: "IBM Plex Mono", monospace;
}

.ReadinessDetail-module__noteMeta___qBtZu {
  flex: 1;
}

.ReadinessDetail-module__noteTitle___yCFa8 {
  font-size: 11px;
  font-weight: 600;
}

.ReadinessDetail-module__noteSub___bNZXb {
  font-size: 11px;
  color: #854d0e;
  margin-left: 6px;
}

.ReadinessDetail-module__noteArrow___emryY {
  font-size: 13px;
  color: #854d0e;
}

.ReadinessDetail-module__sectionProgress___XYKVE {
  padding: 12px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.ReadinessDetail-module__progressHeader___O_8kA {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.ReadinessDetail-module__progressMeta___KhKch {
  font-size: 12px;
  font-weight: 600;
  color: #52525b;
  font-family: "IBM Plex Mono", monospace;
}

.ReadinessDetail-module__progressTrack___QyE88 {
  height: 6px;
  border-radius: 4px;
  background: #f4f4f5;
  overflow: hidden;
}

.ReadinessDetail-module__progressFill___BcElq {
  height: 100%;
  border-radius: 4px;
  transition: width 0.2s ease;
}

.ReadinessDetail-module__progressFillDone___NCors {
  background: #22c55e;
}

.ReadinessDetail-module__progressFillActive___PegEQ {
  background: #eab308;
}

.ReadinessDetail-module__sectionNeeds___vSYQm {
  padding: 12px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.ReadinessDetail-module__sectionLabel___qYkps {
  font-size: 10px;
  font-weight: 600;
  color: #71717a;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
}

.ReadinessDetail-module__tasksBox___Ehwa_ {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 7px;
  overflow: hidden;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.ReadinessDetail-module__tasksSectionHeader___RibE7 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

.ReadinessDetail-module__tasksSummary___OCYxt {
  font-size: 12px;
  color: #a1a1aa;
  font-weight: 500;
}

.ReadinessDetail-module__emptyTasks___lQBzK {
  font-size: 12px;
  color: #71717a;
  line-height: 1.5;
}

.ReadinessDetail-module__taskRowWrap___add1M + .ReadinessDetail-module__taskRowWrap___add1M {
  border-top: 1px solid #f4f4f5;
}

.ReadinessDetail-module__taskRowWrap___add1M {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  background: #ffffff;
  border: 0;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.ReadinessDetail-module__taskRowWrap___add1M:hover {
  background: #fafafa;
}

.ReadinessDetail-module__taskRowDisabled___D3rVE {
  cursor: pointer;
  opacity: 0.45;
}

.ReadinessDetail-module__taskRowDisabled___D3rVE:hover {
  background: #ffffff;
}

.ReadinessDetail-module__taskRowChild___joa8K {
  background: #fafafa;
  border-left-width: 2px;
  border-left-color: #d4d4d8;
  padding-left: 12px;
}

.ReadinessDetail-module__taskRowChild___joa8K:hover {
  background: #f4f4f5;
}

.ReadinessDetail-module__taskRowWrap___add1M:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: -2px;
}

.ReadinessDetail-module__taskRowDisabled___D3rVE:focus-visible {
  outline: none;
}

.ReadinessDetail-module__taskRowactive___atF2t {
  background: #ffffff;
}

.ReadinessDetail-module__taskRowcritical___bajjb {
  background: #ffffff;
}

.ReadinessDetail-module__taskRowPrioritycritical___zq6Ah {
  border-left: 4px solid #dc2626;
  padding-left: 10px;
}

.ReadinessDetail-module__taskRowPriorityhigh___WtsvK {
  border-left: 4px solid #ea580c;
  padding-left: 10px;
}

.ReadinessDetail-module__taskRowPrioritymedium___nYz04 {
  border-left: 3px solid #ca8a04;
  padding-left: 11px;
}

.ReadinessDetail-module__taskRowPrioritylow___VLabg {
  border-left: 2px solid #9ca3af;
  padding-left: 12px;
}

.ReadinessDetail-module__taskRowPriorityLinked___eoZFm {
  border-left: 3px solid #9ca3af;
  padding-left: 11px;
}

.ReadinessDetail-module__taskRowdone___kB2ep {
  background: #f0fdf4;
}

.ReadinessDetail-module__taskRowdone___kB2ep:hover {
  background: #dcfce7;
}

.ReadinessDetail-module__linkedToggle___FPvC_ {
  margin-top: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #a1a1aa;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  width: fit-content;
  cursor: pointer;
  font-size: 11px;
  line-height: 1.2;
}

.ReadinessDetail-module__linkedToggle___FPvC_:hover {
  color: #52525b;
}

.ReadinessDetail-module__linkedToggle___FPvC_:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
  border-radius: 4px;
}

.ReadinessDetail-module__linkedToggleChevron___bwa5s,
.ReadinessDetail-module__linkedToggleIcon___s9Zz7 {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

.ReadinessDetail-module__linkedToggleChevron___bwa5s {
  transition: transform 0.15s ease;
}

.ReadinessDetail-module__linkedToggleChevronOpen___UUrif {
  transform: rotate(90deg);
}

.ReadinessDetail-module__taskCheck___TcC06 {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 2px solid #27272a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  flex-shrink: 0;
}

.ReadinessDetail-module__taskCheckDone___sq1Wu {
  border-width: 1px;
  border-color: #86efac;
  background: #f0fdf4;
  color: #166534;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
}

.ReadinessDetail-module__prerequisiteIcon___mrUyj {
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  flex-shrink: 0;
  color: #a1a1aa;
}

.ReadinessDetail-module__prerequisiteIconGlyph____egtj {
  width: 14px;
  height: 14px;
}

.ReadinessDetail-module__taskContent___HF6ME {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.ReadinessDetail-module__taskMainRow___FCLXY {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
}

.ReadinessDetail-module__taskTitleWrap___cnJfA {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  padding-right: 8px;
}

.ReadinessDetail-module__taskTitleRow___bSTIP {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
}

.ReadinessDetail-module__criticalIcon___WVLFO {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #dc2626;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.ReadinessDetail-module__criticalIconGlyph___zeV7I {
  width: 12px;
  height: 12px;
}

.ReadinessDetail-module__taskTitle___qx32I {
  min-width: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.35;
  color: #18181b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ReadinessDetail-module__taskRowdone___kB2ep .ReadinessDetail-module__taskTitle___qx32I {
  color: #71717a;
  text-decoration: line-through;
}

.ReadinessDetail-module__taskCaption___DNv6P {
  font-size: 12px;
  line-height: 1.45;
  color: #71717a;
  max-width: 28ch;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.ReadinessDetail-module__waitingForRow___MZris {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
  margin-top: 4px;
  margin-left: 12px;
  color: #a1a1aa;
  border: 1px dashed #d4d4d8;
  border-radius: 4px;
  padding: 2px 6px;
}

.ReadinessDetail-module__waitingForIcon___mY4HK {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  margin-top: 1px;
}

.ReadinessDetail-module__waitingForIconGlyph___Vt15_ {
  width: 12px;
  height: 12px;
}

.ReadinessDetail-module__waitingForLabel___UDyes {
  color: #a1a1aa;
  font-size: 11px;
  line-height: 1.35;
  flex-shrink: 0;
}

.ReadinessDetail-module__waitingForTitle___XLVB1 {
  color: #71717a;
  font-size: 11px;
  line-height: 1.35;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.ReadinessDetail-module__taskRightRail___fZNw4 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  margin-top: 1px;
  margin-left: auto;
}

.ReadinessDetail-module__taskDue___xAzv3 {
  flex-shrink: 0;
  font-size: 11px;
  line-height: 1.4;
  color: #a1a1aa;
  font-family: "IBM Plex Mono", monospace;
  white-space: nowrap;
}

.ReadinessDetail-module__priorityBadge___JYXpm {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 11px;
  line-height: 1.2;
  white-space: nowrap;
}

.ReadinessDetail-module__copyButton___tGxVF {
  width: 18px;
  height: 18px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #a1a1aa;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.ReadinessDetail-module__copyButton___tGxVF:hover:not(:disabled) {
  background: #f4f4f5;
  color: #52525b;
}

.ReadinessDetail-module__copyButton___tGxVF:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}

.ReadinessDetail-module__copyButton___tGxVF:disabled {
  cursor: default;
  opacity: 0.45;
}

.ReadinessDetail-module__copyIcon___eDlJu {
  width: 14px;
  height: 14px;
}

.ReadinessDetail-module__priorityBadgecritical___JOeWc {
  background: #fee2e2;
  border-color: #fecaca;
  color: #b91c1c;
  font-weight: 600;
}

.ReadinessDetail-module__priorityBadgehigh___OTrkF {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #c2410c;
}

.ReadinessDetail-module__priorityBadgemedium___OVVBg {
  background: #fefce8;
  border-color: #fef08a;
  color: #a16207;
}

.ReadinessDetail-module__priorityBadgelow____0Sog {
  background: #f9fafb;
  border-color: #e5e7eb;
  color: #6b7280;
}

.ReadinessDetail-module__priorityBadgePulse___t6Z5j {
  animation: ReadinessDetail-module__priorityPulse___N0sIj 1s ease-out 1;
}

@keyframes ReadinessDetail-module__priorityPulse___N0sIj {
  0% {
    transform: scale(1);
  }
  35% {
    transform: scale(1.08);
  }
  100% {
    transform: scale(1);
  }
}
.ReadinessDetail-module__taskDueUrgent___L8tIJ {
  color: #71717a;
  font-weight: 600;
}

.ReadinessDetail-module__taskDueDone___gB7lO {
  color: #166534;
  font-weight: 500;
}

.ReadinessDetail-module__sectionActions___V3Joe {
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ReadinessDetail-module__actionsRow___pW0_t {
  display: block;
}

.ReadinessDetail-module__rescheduleLink___bxYp1 {
  flex: 1;
  padding: 8px 0;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #3f3f46;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  display: block;
}

.ReadinessDetail-module__rescheduleLink___bxYp1:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.ReadinessDetail-module__disabledLink___EYiec {
  cursor: default;
  opacity: 0.6;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ReadinessDetail/ReadinessDetail.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CAAA;AACF;;AAEA;EACE,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;AACF;;AAEA;EACE,0BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE,aAAA;EACA,+BAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,0BAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uCAAA;AACF;;AAEA;EACE,OAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uCAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,2BAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,uFACE;AAAJ;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,eAAA;EACA,aAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,0BAAA;EACA,oBAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,8BAAA;EACA,kBAAA;AAFF;;AAKA;EACE,8BAAA;EACA,kBAAA;AAFF;;AAKA;EACE,8BAAA;EACA,kBAAA;AAFF;;AAKA;EACE,8BAAA;EACA,kBAAA;AAFF;;AAKA;EACE,8BAAA;EACA,kBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,eAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AAFF;;AAKA;;EAEE,WAAA;EACA,YAAA;EACA,cAAA;AAFF;;AAKA;EACE,gCAAA;AAFF;;AAKA;EACE,wBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;AAFF;;AAKA;EACE,OAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,6BAAA;AAFF;;AAKA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uCAAA;EACA,mBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,mBAAA;EACA,cAAA;AAFF;;AAKA;EACE,0BAAA;EACA,mBAAA;AAFF;;AAKA;EACE,eAAA;EACA,aAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAFF;;AAKA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAFF;;AAKA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAFF;;AAKA;EACE,sEAAA;AAFF;;AAKA;EACE;IACE,mBAAA;EAFF;EAIA;IACE,sBAAA;EAFF;EAIA;IACE,mBAAA;EAFF;AACF;AAKA;EACE,cAAA;EACA,gBAAA;AAHF;;AAMA;EACE,cAAA;EACA,gBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,OAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAHF;;AAMA;EACE,0BAAA;EACA,mBAAA;AAHF;;AAMA;EACE,eAAA;EACA,YAAA;AAHF","sourcesContent":[".root {\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.04);\n}\n\n.sectionHeader {\n  padding: 14px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.headerTop {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 4px;\n}\n\n.patientName {\n  font-size: 17px;\n  font-weight: 600;\n  color: #18181b;\n  line-height: 1.35;\n}\n\n.visitType {\n  font-size: 14px;\n  color: #52525b;\n  margin-top: 2px;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 16px;\n  color: #a1a1aa;\n  cursor: pointer;\n  padding: 0;\n}\n\n.closeButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.badgesRow {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.visitDescription {\n  font-size: 13px;\n  color: #71717a;\n  line-height: 1.5;\n}\n\n.sectionInfo {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.infoGrid {\n  display: grid;\n  grid-template-columns: 72px 1fr;\n  gap: 4px 0;\n  font-size: 13px;\n  margin-bottom: 8px;\n}\n\n.infoRow {\n  display: contents;\n}\n\n.infoLabel {\n  color: #a1a1aa;\n  font-weight: 500;\n}\n\n.infoValue {\n  color: #3f3f46;\n}\n\n.linkWrap {\n  margin-top: 8px;\n}\n\n.noteLink {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  margin-top: 6px;\n  background: #fefce8;\n  border: 1px solid #fde68a;\n  border-radius: 6px;\n  text-decoration: none;\n  color: #18181b;\n  cursor: pointer;\n  transition: border-color 0.15s;\n}\n\n.noteLink:hover {\n  border-color: #eab308;\n}\n\n.noteLink:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.noteBadge {\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  background: #854d0e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.noteBadgeText {\n  font-size: 10px;\n  font-weight: 700;\n  color: #fefce8;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.noteMeta {\n  flex: 1;\n}\n\n.noteTitle {\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.noteSub {\n  font-size: 11px;\n  color: #854d0e;\n  margin-left: 6px;\n}\n\n.noteArrow {\n  font-size: 13px;\n  color: #854d0e;\n}\n\n.sectionProgress {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.progressHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.progressMeta {\n  font-size: 12px;\n  font-weight: 600;\n  color: #52525b;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.progressTrack {\n  height: 6px;\n  border-radius: 4px;\n  background: #f4f4f5;\n  overflow: hidden;\n}\n\n.progressFill {\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.2s ease;\n}\n\n.progressFillDone {\n  background: #22c55e;\n}\n\n.progressFillActive {\n  background: #eab308;\n}\n\n.sectionNeeds {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.sectionLabel {\n  font-size: 10px;\n  font-weight: 600;\n  color: #71717a;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 8px;\n}\n\n.tasksBox {\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 7px;\n  overflow: hidden;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);\n}\n\n.tasksSectionHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.tasksSummary {\n  font-size: 12px;\n  color: #a1a1aa;\n  font-weight: 500;\n}\n\n.emptyTasks {\n  font-size: 12px;\n  color: #71717a;\n  line-height: 1.5;\n}\n\n.taskRowWrap + .taskRowWrap {\n  border-top: 1px solid #f4f4f5;\n}\n\n.taskRowWrap {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 14px;\n  background: #ffffff;\n  border: 0;\n  text-align: left;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease,\n    box-shadow 0.15s ease;\n}\n\n.taskRowWrap:hover {\n  background: #fafafa;\n}\n\n.taskRowDisabled {\n  cursor: pointer;\n  opacity: 0.45;\n}\n\n.taskRowDisabled:hover {\n  background: #ffffff;\n}\n\n.taskRowChild {\n  background: #fafafa;\n  border-left-width: 2px;\n  border-left-color: #d4d4d8;\n  padding-left: 12px;\n}\n\n.taskRowChild:hover {\n  background: #f4f4f5;\n}\n\n.taskRowWrap:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: -2px;\n}\n\n.taskRowDisabled:focus-visible {\n  outline: none;\n}\n\n.taskRowactive {\n  background: #ffffff;\n}\n\n.taskRowcritical {\n  background: #ffffff;\n}\n\n.taskRowPrioritycritical {\n  border-left: 4px solid #dc2626;\n  padding-left: 10px;\n}\n\n.taskRowPriorityhigh {\n  border-left: 4px solid #ea580c;\n  padding-left: 10px;\n}\n\n.taskRowPrioritymedium {\n  border-left: 3px solid #ca8a04;\n  padding-left: 11px;\n}\n\n.taskRowPrioritylow {\n  border-left: 2px solid #9ca3af;\n  padding-left: 12px;\n}\n\n.taskRowPriorityLinked {\n  border-left: 3px solid #9ca3af;\n  padding-left: 11px;\n}\n\n.taskRowdone {\n  background: #f0fdf4;\n}\n\n.taskRowdone:hover {\n  background: #dcfce7;\n}\n\n.linkedToggle {\n  margin-top: 4px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #a1a1aa;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  width: fit-content;\n  cursor: pointer;\n  font-size: 11px;\n  line-height: 1.2;\n}\n\n.linkedToggle:hover {\n  color: #52525b;\n}\n\n.linkedToggle:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.linkedToggleChevron,\n.linkedToggleIcon {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n}\n\n.linkedToggleChevron {\n  transition: transform 0.15s ease;\n}\n\n.linkedToggleChevronOpen {\n  transform: rotate(90deg);\n}\n\n.taskCheck {\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  border: 2px solid #27272a;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n.taskCheckDone {\n  border-width: 1px;\n  border-color: #86efac;\n  background: #f0fdf4;\n  color: #166534;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.prerequisiteIcon {\n  width: 16px;\n  height: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2px;\n  flex-shrink: 0;\n  color: #a1a1aa;\n}\n\n.prerequisiteIconGlyph {\n  width: 14px;\n  height: 14px;\n}\n\n.taskContent {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.taskMainRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  min-width: 0;\n}\n\n.taskTitleWrap {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  padding-right: 8px;\n}\n\n.taskTitleRow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.criticalIcon {\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  background: #dc2626;\n  color: #ffffff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.criticalIconGlyph {\n  width: 12px;\n  height: 12px;\n}\n\n.taskTitle {\n  min-width: 0;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.35;\n  color: #18181b;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.taskRowdone .taskTitle {\n  color: #71717a;\n  text-decoration: line-through;\n}\n\n.taskCaption {\n  font-size: 12px;\n  line-height: 1.45;\n  color: #71717a;\n  max-width: 28ch;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.waitingForRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  min-width: 0;\n  margin-top: 4px;\n  margin-left: 12px;\n  color: #a1a1aa;\n  border: 1px dashed #d4d4d8;\n  border-radius: 4px;\n  padding: 2px 6px;\n}\n\n.waitingForIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.waitingForIconGlyph {\n  width: 12px;\n  height: 12px;\n}\n\n.waitingForLabel {\n  color: #a1a1aa;\n  font-size: 11px;\n  line-height: 1.35;\n  flex-shrink: 0;\n}\n\n.waitingForTitle {\n  color: #71717a;\n  font-size: 11px;\n  line-height: 1.35;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.taskRightRail {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  margin-top: 1px;\n  margin-left: auto;\n}\n\n.taskDue {\n  flex-shrink: 0;\n  font-size: 11px;\n  line-height: 1.4;\n  color: #a1a1aa;\n  font-family: 'IBM Plex Mono', monospace;\n  white-space: nowrap;\n}\n\n.priorityBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px 6px;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  font-size: 11px;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.copyButton {\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  color: #a1a1aa;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.copyButton:hover:not(:disabled) {\n  background: #f4f4f5;\n  color: #52525b;\n}\n\n.copyButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 1px;\n}\n\n.copyButton:disabled {\n  cursor: default;\n  opacity: 0.45;\n}\n\n.copyIcon {\n  width: 14px;\n  height: 14px;\n}\n\n.priorityBadgecritical {\n  background: #fee2e2;\n  border-color: #fecaca;\n  color: #b91c1c;\n  font-weight: 600;\n}\n\n.priorityBadgehigh {\n  background: #fff7ed;\n  border-color: #fed7aa;\n  color: #c2410c;\n}\n\n.priorityBadgemedium {\n  background: #fefce8;\n  border-color: #fef08a;\n  color: #a16207;\n}\n\n.priorityBadgelow {\n  background: #f9fafb;\n  border-color: #e5e7eb;\n  color: #6b7280;\n}\n\n.priorityBadgePulse {\n  animation: priorityPulse 1s ease-out 1;\n}\n\n@keyframes priorityPulse {\n  0% {\n    transform: scale(1);\n  }\n  35% {\n    transform: scale(1.08);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.taskDueUrgent {\n  color: #71717a;\n  font-weight: 600;\n}\n\n.taskDueDone {\n  color: #166534;\n  font-weight: 500;\n}\n\n.sectionActions {\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.actionsRow {\n  display: block;\n}\n\n.rescheduleLink {\n  flex: 1;\n  padding: 8px 0;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  border: 1px solid #d4d4d8;\n  background: #ffffff;\n  color: #3f3f46;\n  cursor: pointer;\n  text-decoration: none;\n  text-align: center;\n  display: block;\n}\n\n.rescheduleLink:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.disabledLink {\n  cursor: default;\n  opacity: 0.6;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ReadinessDetail-module__root___xV3KU`,
	"sectionHeader": `ReadinessDetail-module__sectionHeader___ocXVd`,
	"headerTop": `ReadinessDetail-module__headerTop___EgaUC`,
	"patientName": `ReadinessDetail-module__patientName___AXlVZ`,
	"visitType": `ReadinessDetail-module__visitType___C4qE5`,
	"closeButton": `ReadinessDetail-module__closeButton___j0ffB`,
	"badgesRow": `ReadinessDetail-module__badgesRow___CT_sm`,
	"visitDescription": `ReadinessDetail-module__visitDescription___UYUk4`,
	"sectionInfo": `ReadinessDetail-module__sectionInfo___MgFiV`,
	"infoGrid": `ReadinessDetail-module__infoGrid___ACJCM`,
	"infoRow": `ReadinessDetail-module__infoRow___mEYHw`,
	"infoLabel": `ReadinessDetail-module__infoLabel___wM8fF`,
	"infoValue": `ReadinessDetail-module__infoValue___UDxWu`,
	"linkWrap": `ReadinessDetail-module__linkWrap___PC0Da`,
	"noteLink": `ReadinessDetail-module__noteLink___zhTX9`,
	"noteBadge": `ReadinessDetail-module__noteBadge___AmpjM`,
	"noteBadgeText": `ReadinessDetail-module__noteBadgeText___hOfMV`,
	"noteMeta": `ReadinessDetail-module__noteMeta___qBtZu`,
	"noteTitle": `ReadinessDetail-module__noteTitle___yCFa8`,
	"noteSub": `ReadinessDetail-module__noteSub___bNZXb`,
	"noteArrow": `ReadinessDetail-module__noteArrow___emryY`,
	"sectionProgress": `ReadinessDetail-module__sectionProgress___XYKVE`,
	"progressHeader": `ReadinessDetail-module__progressHeader___O_8kA`,
	"progressMeta": `ReadinessDetail-module__progressMeta___KhKch`,
	"progressTrack": `ReadinessDetail-module__progressTrack___QyE88`,
	"progressFill": `ReadinessDetail-module__progressFill___BcElq`,
	"progressFillDone": `ReadinessDetail-module__progressFillDone___NCors`,
	"progressFillActive": `ReadinessDetail-module__progressFillActive___PegEQ`,
	"sectionNeeds": `ReadinessDetail-module__sectionNeeds___vSYQm`,
	"sectionLabel": `ReadinessDetail-module__sectionLabel___qYkps`,
	"tasksBox": `ReadinessDetail-module__tasksBox___Ehwa_`,
	"tasksSectionHeader": `ReadinessDetail-module__tasksSectionHeader___RibE7`,
	"tasksSummary": `ReadinessDetail-module__tasksSummary___OCYxt`,
	"emptyTasks": `ReadinessDetail-module__emptyTasks___lQBzK`,
	"taskRowWrap": `ReadinessDetail-module__taskRowWrap___add1M`,
	"taskRowDisabled": `ReadinessDetail-module__taskRowDisabled___D3rVE`,
	"taskRowChild": `ReadinessDetail-module__taskRowChild___joa8K`,
	"taskRowactive": `ReadinessDetail-module__taskRowactive___atF2t`,
	"taskRowcritical": `ReadinessDetail-module__taskRowcritical___bajjb`,
	"taskRowPrioritycritical": `ReadinessDetail-module__taskRowPrioritycritical___zq6Ah`,
	"taskRowPriorityhigh": `ReadinessDetail-module__taskRowPriorityhigh___WtsvK`,
	"taskRowPrioritymedium": `ReadinessDetail-module__taskRowPrioritymedium___nYz04`,
	"taskRowPrioritylow": `ReadinessDetail-module__taskRowPrioritylow___VLabg`,
	"taskRowPriorityLinked": `ReadinessDetail-module__taskRowPriorityLinked___eoZFm`,
	"taskRowdone": `ReadinessDetail-module__taskRowdone___kB2ep`,
	"linkedToggle": `ReadinessDetail-module__linkedToggle___FPvC_`,
	"linkedToggleChevron": `ReadinessDetail-module__linkedToggleChevron___bwa5s`,
	"linkedToggleIcon": `ReadinessDetail-module__linkedToggleIcon___s9Zz7`,
	"linkedToggleChevronOpen": `ReadinessDetail-module__linkedToggleChevronOpen___UUrif`,
	"taskCheck": `ReadinessDetail-module__taskCheck___TcC06`,
	"taskCheckDone": `ReadinessDetail-module__taskCheckDone___sq1Wu`,
	"prerequisiteIcon": `ReadinessDetail-module__prerequisiteIcon___mrUyj`,
	"prerequisiteIconGlyph": `ReadinessDetail-module__prerequisiteIconGlyph____egtj`,
	"taskContent": `ReadinessDetail-module__taskContent___HF6ME`,
	"taskMainRow": `ReadinessDetail-module__taskMainRow___FCLXY`,
	"taskTitleWrap": `ReadinessDetail-module__taskTitleWrap___cnJfA`,
	"taskTitleRow": `ReadinessDetail-module__taskTitleRow___bSTIP`,
	"criticalIcon": `ReadinessDetail-module__criticalIcon___WVLFO`,
	"criticalIconGlyph": `ReadinessDetail-module__criticalIconGlyph___zeV7I`,
	"taskTitle": `ReadinessDetail-module__taskTitle___qx32I`,
	"taskCaption": `ReadinessDetail-module__taskCaption___DNv6P`,
	"waitingForRow": `ReadinessDetail-module__waitingForRow___MZris`,
	"waitingForIcon": `ReadinessDetail-module__waitingForIcon___mY4HK`,
	"waitingForIconGlyph": `ReadinessDetail-module__waitingForIconGlyph___Vt15_`,
	"waitingForLabel": `ReadinessDetail-module__waitingForLabel___UDyes`,
	"waitingForTitle": `ReadinessDetail-module__waitingForTitle___XLVB1`,
	"taskRightRail": `ReadinessDetail-module__taskRightRail___fZNw4`,
	"taskDue": `ReadinessDetail-module__taskDue___xAzv3`,
	"priorityBadge": `ReadinessDetail-module__priorityBadge___JYXpm`,
	"copyButton": `ReadinessDetail-module__copyButton___tGxVF`,
	"copyIcon": `ReadinessDetail-module__copyIcon___eDlJu`,
	"priorityBadgecritical": `ReadinessDetail-module__priorityBadgecritical___JOeWc`,
	"priorityBadgehigh": `ReadinessDetail-module__priorityBadgehigh___OTrkF`,
	"priorityBadgemedium": `ReadinessDetail-module__priorityBadgemedium___OVVBg`,
	"priorityBadgelow": `ReadinessDetail-module__priorityBadgelow____0Sog`,
	"priorityBadgePulse": `ReadinessDetail-module__priorityBadgePulse___t6Z5j`,
	"priorityPulse": `ReadinessDetail-module__priorityPulse___N0sIj`,
	"taskDueUrgent": `ReadinessDetail-module__taskDueUrgent___L8tIJ`,
	"taskDueDone": `ReadinessDetail-module__taskDueDone___gB7lO`,
	"sectionActions": `ReadinessDetail-module__sectionActions___V3Joe`,
	"actionsRow": `ReadinessDetail-module__actionsRow___pW0_t`,
	"rescheduleLink": `ReadinessDetail-module__rescheduleLink___bxYp1`,
	"disabledLink": `ReadinessDetail-module__disabledLink___EYiec`
};
module.exports = ___CSS_LOADER_EXPORT___;
